import { Button, Modal } from 'antd';
import React from 'react';


export default class ConfirmButton extends React.Component{
    confirm = () =>  {
        Modal.confirm({
          title: 'Confirm',
          content: <div style={{ color: this.props.descriptionColor || "black" }}> {/* Change 'red' to your desired color */}
          {this.props.description}
        </div>,
          okText: 'Confirm',
          cancelText: 'Cancel',
          onOk: (close) => {
            this.props.onConfirm();
            close();
          },
      
        });
      }

      render(){
        const {type ,label, loading, disabled } = this.props;
        return(
            <div>
                <Button type={type} onClick={this.confirm} loading={loading} disabled={disabled || false}>
                    {label}
                </Button>
            </div>
        )
      }
}